import { mapActions, mapGetters } from 'vuex'

export default {
  data(){
    return{
      sortOptions: {
        sortBy: [],
        sortDesc: []
      }
    }
  },
  computed: {
    ...mapGetters(['getSort'])
  },
  methods: {
    ...mapActions(['setSortBy', 'setSortDesc']),
    sortByHandler(event, page){
      this.setSortBy({page: page, value: event})
    },
    sortDescHandler(event, page){
      this.setSortDesc({page: page, value: event})
    },
    setInitialSort(page){
      const sortState = this.getSort(page)
      if (sortState){
        this.sortOptions.sortBy = Array.isArray(sortState.sortBy) ? sortState.sortBy : [sortState.sortBy]
        this.sortOptions.sortDesc = Array.isArray(sortState.sortDesc) ? sortState.sortDesc : [sortState.sortDesc]
      }
      else
        console.warn(`Sort by ${page} not found in state`)
    }
  }
}
